export default __webpack_public_path__ + "static/visit-bee72fb99f4c4f14a70138ffafc5dd75.webp";